import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { URL_GLOBAL } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ComentariosmedicaoService {
    constructor(private http: HttpClient) { }

    getAll(): Observable<any[]> {
        return this.http.get<any[]>(`${URL_GLOBAL}/comentariosmedicao`);
    }

    save(data: any): Observable<any> {
        return this.http.post<any>(`${URL_GLOBAL}/comentariosmedicao`, data);
    }

    find(id: any): Observable<any> {
        return this.http.get(`${`${URL_GLOBAL}/comentariosmedicao`}/${id}`);
    }

    update(id: any, data: any): Observable<any> {
        return this.http.put<any>(`${`${URL_GLOBAL}/comentariosmedicao`}/${id}`, data);
    }

    destroy(id: any): Observable<any> {
        return this.http.delete<any>(`${`${URL_GLOBAL}/comentariosmedicao`}/${id}`);
    }
    buscaComentariosPorIdMedicao(medicao_id: any): Observable<any[]> {
        return this.http.get<any[]>(`${URL_GLOBAL}/comentariosmedicao/buscaComentariosPorIdMedicao/${medicao_id}`);
    }
}
